import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102077.jpg'
import img2 from '../assets/others/11102078.jpg'
import img3 from '../assets/others/11102079.jpg'
import img4 from '../assets/others/11102076.jpg'
import Courseintern from '../Components/Courseintern/Courseintern'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Corefeature from '../Components/Corefeature/Corefeature'
import Recruitersec from '../Components/Recruitersec/Recruitersec'
import Reviewsec from '../Components/Reviewsec/Reviewsec'
import Iconbox from '../Components/Iconbox/Iconbox'
import { Helmet } from 'react-helmet'
library.add(fas)

const Internship = () => {
  return (
    <div>
        <Helmet>
        <title>Takshila VLSI Internship Program</title>
        <meta name="description" content="Takshila VLSI offers all backend VLSI courses at low cost. VLSI training center located near Marathahalli." />
        
        </Helmet>
        <Header/> 
        <main>
        <section className='section-banner pg-banner bg-6'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-5 pb-3">
                                <div class="pg-title-sec pl-r-12">
                                    <h1 className='pg-title'>VLSI Internship
                                    </h1>
                                    <p className='pg-title-desc'>Gaining Practical Experience and Industry Insights through Internship
                                    </p>
                                </div>
                              </div>
                              <div class="col-md-12 align-self-center mb-4">
                                <a href='/register-now'>
                                    <button class="btn-primary btn-icon" href="index.html#about">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                              </a>
                              </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-lg-3 img-radius align-self-end d-none d-sm-block">
                            <img src={img} alt=''/>
                          </div>
                          <div class="col-lg-4 img-radius align-self-end d-none d-sm-block">
                            <img src={img2} alt=''/>
                          </div>
                          <div class="col-lg-3 img-radius align-self-end">
                            <img src={img3} alt=''/>
                          </div>
                          </div>
            </div>
            </section>
            <section className='course-desc p-lg-5 bg-14 pt-5'>
                <div class="container text-center">
                         <div class="row justify-content-around text-center">
                              <div class="col-md p-lg-5 pb-0">
                                    <h2 className='ws-section_heading pd-03'><span className='font-thin'>Transforming students into </span>industry-ready Professionals</h2>
                              </div>
                          </div>
                          <div class="row justify-content-around">
                              <div class="col-md">
                                    <div className='text-left text-xl'>
                                    <p>At Takshila VLSI, we are passionate about empowering students to reach their full potential through high-quality training and development programs. With a rich history of 15 years of excellence and a commitment to continuous improvement, we have become a trusted partner for those seeking to enhance their skills, knowledge, and capabilities.
                                    We bridge the gap between academia and the professional world, empowering young talents to embark on their career journeys with confidence and competence.</p></div>
                              </div>
                          </div>
                </div>
          </section>
             <Courseintern/>
             <Corefeature/>
             <Reviewsec/>
             <section className='pb-5'>
            <Iconbox/>
            </section>
            <section className='ws-section pb-5'>
                <div class="row mb-5">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading pd-03'>Connect With Us</h2>
                        </div>
                    </div>
          <div className='container'>
          <div class="row">
                <div class="col-lg img-radius">
                <img src={img4} alt=''/>
                </div>
                <div class="col-lg">
                  <div className='ctn-frm'>
                  <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                </div>
                </div>
                
            </div>
            </div>
          </section>
            
        </main> 
        <Enrollaction/>
        <Partnersec/> 
        <Footer/> 
    </div>
  )
}

export default Internship